import { render } from "./ChevronsRight.vue?vue&type=template&id=925c96b6&scoped=true"
const script = {}

import "./ChevronsRight.vue?vue&type=style&index=0&id=925c96b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-925c96b6"]])

export default __exports__